import { Column, Row } from 'Components/Grid'
import styled from 'styled-components'

export const RowExhibition = styled(Row)`
  border-bottom: 1px solid var(--vo-escuro-8);
  min-height: 38px;
`

export const RowExhibitionLight = styled(Row)`
  border-bottom: 1px solid var(--vo-white);
  min-height: 38px;
`

export const ColumnEdit = styled(Column)`
  display: flex;
`

export const CardStyled = styled.div`
  border: solid 2px var(--vo-cloud) !important;
  border-radius: 8px;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-inline: 1rem;
`

export const TitleModalDetail = styled.div`
  font-weight: 700;
  font-size: 18px;
  text-align: start;
  margin: 0;
`

export const SubTitleModalDetail = styled.div`
  color: var(--vo-slate);
  text-align: start;
  margin: 0;
  font-size: 14px;
`